import { motion } from 'framer-motion';
import ScrollReveal from '@/components/base/ScrollReveal';

const categories = [
  {
    icon: 'ri-facebook-fill',
    title: 'Prompts para Meta Ads',
    desc: 'Facebook e Instagram Ads optimizados para conversión y engagement.',
    color: 'bg-primary-50 text-primary-600',
  },
  {
    icon: 'ri-google-fill',
    title: 'Prompts para Campañas Publicitarias',
    desc: 'Imágenes y videos para Meta Ads y TikTok Ads.',
    color: 'bg-accent-50 text-accent-600',
  },
  {
    icon: 'ri-music-fill',
    title: 'Prompts para TikTok Ads',
    desc: 'Hooks virales, guiones y creatividades para TikTok.',
    color: 'bg-foreground-100 text-foreground-700',
  },
  {
    icon: 'ri-edit-line',
    title: 'Prompts para Copywriting',
    desc: 'Copy persuasivo para cualquier plataforma y objetivo de venta.',
    color: 'bg-primary-50 text-primary-600',
  },
  {
    icon: 'ri-palette-line',
    title: 'Prompts para Creativos',
    desc: 'Ideas para imágenes, videos, carruseles y anuncios visuales.',
    color: 'bg-accent-50 text-accent-600',
  },
];

export default function WhatYouFind() {
  return (
    <section id="contenido" className="relative bg-white py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              Contenido
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              ¿Qué encontrarás?
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
              Una biblioteca completa organizada por plataforma y objetivo para que encuentres exactamente lo que necesitas.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((cat, i) => (
            <ScrollReveal key={cat.title} delay={i * 0.08}>
              <motion.div
                whileHover={{ y: -6, transition: { duration: 0.3 } }}
                className="group relative bg-white rounded-2xl border border-foreground-100 p-7 md:p-8 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] hover:border-foreground-200 transition-all duration-300"
              >
                <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center mb-5`}>
                  <i className={`${cat.icon} text-xl`} />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                  {cat.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {cat.desc}
                </p>
                <div className="absolute bottom-7 right-7 md:bottom-8 md:right-8 w-8 h-8 rounded-full bg-foreground-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-line text-foreground-400 text-sm" />
                </div>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}